/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
  Checkbox,
  FormControlLabel,
  Radio,
  TextField,
} from '@material-ui/core';
import { Button } from 'react-bootstrap';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import { AllManufacturer } from './TableHead';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import {
  ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
  REBATE_SELECT,
} from '../../../../SharedModules/Errors/constantMessageData';
import {
  getManufacturerList,
  setOutstandingForQuarter,
  getPlanTypeValues,
  getRebateProgrameList,
  getOustandingDisputesQuarterHeader,
  setSearchInput,
} from '../Store/actions';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  getCurrentQtr,
  convertToFourDigitYear,
  validateQuarter,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';

import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

const OutstandingDisputesForQuarter = (props) => {
  const currentQtr = getCurrentQtr()?.join('Q');
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    manufacturerList: resultanufacturerList,
    outstandingDisputesQuarterHeader,
    // isAllManufacturersSelected: isAllManufacturersSelectedValue,
    scrollDownManufacturers: scrollDownManufacturersValue,
    // allRebateProgram: allRebateProgramValue,
    selectedRowIndexValue,
    // quarterValue,
    searchScreenVar: {
      rebateProgramValue,
      selectedPlanType,
      quarterValue,
      allRebateProgram: allRebateProgramValue,
      isAllManufacturersSelected: isAllManufacturersSelectedValue,
      // scrollDownManufacturers: true,
    },
  } = useSelector(
    (state) => state?.sharedState?.OutstandingDisputesForQuarterReducer
  );
  const OutstandingDisputesForQuarterReducer = useSelector(
    (state) => state?.sharedState?.OutstandingDisputesForQuarterReducer
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );
  const [errorList, setErrorList] = React.useState(errors);
  const [fullScreenView, setfullScreenView] = React.useState(false);
  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };
  const [manufacturerList, setManufacturerList] = React.useState([]);
  const [allRebateProgram, setAllRebateProgram] = React.useState(
    allRebateProgramValue
  );
  const [isAllManufacturersSelected, setIsAllManufacturersSelected] =
    React.useState(isAllManufacturersSelectedValue);
  const [manufacturerSelected, setManufacturerSelected] = React.useState(
    isAllManufacturersSelectedValue ? ['ALL'] : []
  );
  const [scrollDownManufacturers, setScrollDownManufacturers] = React.useState(
    scrollDownManufacturersValue
  );
  const [quarter, setQuarter] = React.useState(quarterValue || currentQtr);
  // To know that search button is pressed
  const [isSearchClicked, setSearchClicked] = React.useState(false);
  const [selectedRowIndex, setSelectedRowIndex] = React.useState(
    selectedRowIndexValue
  );

  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
          disabled: allRebateProgram,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList, allRebateProgram]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // To get manufacturer List
  React.useEffect(() => {
    dispatch(
      getManufacturerList({
        planType: 'fd',
        asMode: 1,
      })
    );
  }, []);

  // Manufacturer Grid From API
  React.useEffect(() => {
    setManufacturerList(resultanufacturerList?.rebatePercentOfSpendMfgGridVO);
  }, [resultanufacturerList]);

  // To change the manufacturer grid as per the plan type selection
  const handleOnChangeEvent = (value, name) => {
    if (name === 'planTypeCd') {
      if (value === 'ST' || value === 'FD') {
        dispatch(
          getManufacturerList({
            planType: 'st',
            asMode: 1,
          })
        );
      }
      if (value === 'SUPP' || value === 'COMM') {
        dispatch(
          getManufacturerList({
            planType: 'supp',
            asMode: 1,
          })
        );
      }
    }
  };

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value?.split('Q');
    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue?.join('Q');
  };

  // Handle onblur events for date and quarter
  const handleOnBlur = (type, value) => {
    let localErrors = errorList;
    if (type === 'qtr') {
      localErrors = localErrors.filter((error) => error.field != 'qtr');
      const qtrErr = validateQuarter(value, 'qtr',true);
      if (qtrErr.length === 0) {
        const qtr = value.length == 4 ? convertTo4DigitQtr(value) : value;
        setQuarter(qtr);
        dispatch(
          setSearchInput({
            ...OutstandingDisputesForQuarterReducer,
            quarterValue: qtr,
          })
        );
      } else {
        localErrors = [...localErrors, ...qtrErr];
      }
    }
    setErrorList(localErrors);
    dispatch(
      setSearchInput({
        ...OutstandingDisputesForQuarterReducer,
        errors: localErrors,
        quarterValue: quarter,
      })
    );
  };

  // On selection of the row data
  const onSelectionChanged = (e) => {
    // let manuError = [];

    const selectedRows = e.api?.getSelectedRows();
    const selectedMfgId = selectedRows?.map((item) => item.mfgId);
    const selectedIndexes = [];
    if (manufacturerList) {
      manufacturerList.forEach((item, index) => {
        if (selectedMfgId?.indexOf(item.mfgId) != -1) {
          selectedIndexes.push(index);
        }
      });
    }
    setSelectedRowIndex(selectedIndexes);
    if (
      selectedRows?.length === manufacturerList?.length
      // || selectedRows.length === 0
    ) {
      setManufacturerSelected(['ALL']);
    } else {
      const selectedManuId = [];
      for (let i = 0; i < selectedRows?.length; i += 1) {
        selectedManuId.push(selectedRows[i].mfgId);
      }
      selectedManuId.sort();
      setManufacturerSelected(selectedManuId);
    }
    const errors = errorList.filter((error) => error.field !== 'manufacturer');
    setErrorList([...errors]);
    dispatch(
      setSearchInput({
        ...OutstandingDisputesForQuarterReducer,
        errors: errors,
      })
    );
    // setErrorList(manuError);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen
  const handleSearchClick = () => {
    let allErrors = [];
    const manuError = [];
    if (rebateProgram === '-1' && allRebateProgram === false) {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    if (
      manufacturerSelected.length === 0 &&
      isAllManufacturersSelected === false
    ) {
      allErrors.push({
        field: 'manufacturer',
        message: ERRORMESSAGE_MFR_NOT_EMPTY_FOR_UNIT_CONVERSION,
      });
    }

    allErrors = [...allErrors, ...errorList];

    setErrorList(allErrors);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList?.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    dispatch(
      setSearchInput({
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        rebateProgramName,
        manufacturerSelected,
        quarterValue: quarter,
        allRebateProgram,
        rebateProgrameName,
        isAllManufacturersSelected,
        selectedRowIndexValue: selectedRowIndex,
        scrollDownManufacturers,
        searchScreenVar: {
          selectedPlanType: planType,
          rebateProgramValue: rebateProgram,
          quarterValue: quarter,
          allRebateProgram,
          rebateProgrameName,
          isAllManufacturersSelected,
          // scrollDownManufacturers: true,
        },
      })
    );

    if (allErrors.length === 0) {
      setSearchClicked(true);
      dispatch(setOutstandingForQuarter([]));
      dispatch(
        getOustandingDisputesQuarterHeader({
          quarter: quarter,
          rebateProgramCd: allRebateProgram ? 'ALL' : rebateProgram,
          mfgId: manufacturerSelected,
          aiAll: manufacturerSelected[0] === 'ALL' ? '1' : '0',
        })
      );
    }
    /*
        if all the  error is cleaered then it will go to if block and
        set store value and navigate to Displayy Screen
    * */

    if (allErrors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
    if (isSearchClicked && errors.length > 0) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  }, [errors]);

  if (
    isSearchClicked &&
    outstandingDisputesQuarterHeader &&
    outstandingDisputesQuarterHeader.length > 0
  ) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/displayOutstandingDisputesForQuarter',
      value: 'Display Outstanding Dispute For Quarters',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props?.history) {
      props.history.push({
        pathname: '/displayOutstandingDisputesForQuarter',
      });
    }
    dispatch(
      clearReduxForFilterAndSort('/displayOutstandingDisputesForQuarter')
    );
  }

  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  // handing highlight tab
  React.useEffect(() => {
    if (errorMessages?.length > 0) {
      tabHighLigther('/outstandingDisputesForQuarter', true);
    } else {
      tabHighLigther('/outstandingDisputesForQuarter', false);
    }
  }, [JSON.stringify(errorMessages)]);
              
  // remove no data error msg
  React.useEffect(() => {
    dispatch(setSearchInput({ errors: [] }));
  }, [ planType, AllManufacturer, planTypeList, rebateProgram, quarter, fullScreenView, selectedRowIndexValue, allRebateProgram, isAllManufacturersSelected, scrollDownManufacturers]);

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <>
          <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
          <CustomSeparator
            parent1="State Reports"
            parent2="Outstanding Disputes For Quarter"
          />
        </>
      )}

      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          <div className="row ml-2 mb-3 ">
            <div className="col-4 ">
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    name="allRebateProgram"
                    checked={allRebateProgram}
                    onBlur={() => {}}
                    onChange={() => {
                      setAllRebateProgram(!allRebateProgram);
                      const tempRadioList = radioList?.map((item) => {
                        return { ...item, disabled: !allRebateProgram };
                      });
                      setRadioList(tempRadioList);
                      if (!allRebateProgram) {
                        const errors = errorList.filter(
                          (error) => error.field !== 'rebateProgram'
                        );
                        setErrorList([...errors]);
                      }
                    }}
                  />
                }
                label="All Rebate Programs"
              />
            </div>
            <div className="col-4">
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isAllManufacturersSelected}
                    color="primary"
                    name="allManufacturers"
                    onChange={async (e) => {
                      setIsAllManufacturersSelected(
                        !isAllManufacturersSelected
                      );
                      setScrollDownManufacturers(!scrollDownManufacturers);
                      if (!isAllManufacturersSelected) {
                        setManufacturerSelected(['ALL']);
                      } else {
                        setManufacturerSelected([]);
                      }

                      const elem = document.getElementById('abc11');
                      if (elem && scrollDownManufacturers) {
                        await Promise.resolve();
                        // setTimeout(() => {
                          elem.scrollIntoView();
                        // }, 1000);
                      }
                      const errors = errorList.filter(
                        (error) => error.field !== 'manufacturer'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'manufacturer')
                        ?.message
                    }
                  />
                }
                label="All Manufacturers"
              />
            </div>
          </div>
          <div className="row">
            <div className="col-4 frr-two-col-radio">
              <RadioGroupComponent
                data-testid="OutsatandingQtr_Plantype"
                id="filter-plan-by-radio-btn-action"
                required
                labelName="Plan Type"
                optionList={radioList || []}
                defaultValue={planType}
                filterAction={(value) => {
                  setPlanType(value);
                  setRebateProgram('-1');
                  handleOnChangeEvent(value, 'planTypeCd');
                  const errors = errorList.filter(
                    (error) => error.field !== 'rebateProgram'
                  );
                  setErrorList([...errors]);
                }}
                className="log-batch-filter-radio frr-checkInvoiceRadio"
              />
            </div>
            <div className="col-4">
              <>
                <Fieldset label="Rebate Program" required>
                  <div>
                    <SelectBoxComponent
                      disabled={allRebateProgram}
                      data-testid="OutsatandingQtr_RebateProgram"
                      id="filter-plan-by-radio-btn-action"
                      labelName="Rebate Program"
                      required
                      select
                      selectOne
                      optionList={selectList || []}
                      defaultValue={rebateProgram}
                      filterAction={(value) => {
                        setRebateProgram(value);
                        setRebateProgramName(value);
                        const errors = errorList.filter(
                          (error) => error.field !== 'rebateProgram'
                        );
                        setErrorList([...errors]);
                      }}
                      isError={
                        errorList.find(
                          (error) => error.field === 'rebateProgram'
                        )?.message
                      }
                    />
                  </div>
                </Fieldset>
              </>
            </div>
            <div className="col-3 mt-2">
              <div className="mui-custom-form input-md field-xl">
                <TextField
                  label="Quarter"
                  id="Quarter"
                  data-testid="OutstandingQtr_Qtarter"
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  inputProps={{ maxLength: 6 }}
                  required
                  name="qtr"
                  value={quarter}
                  error={
                    errorList.filter((error) => error.field === 'qtr')?.length >
                    0
                      ? 'mandate-fields'
                      : ''
                  }
                  helperText={
                    errorList.find((error) => error.field === 'qtr')?.message
                  }
                  className="mandate-fields"
                  onBlur={(e) => handleOnBlur('qtr', e.target.value)}
                  onChange={(e) => {
                    const { value } = e.target;
                    setQuarter(value.toUpperCase());
                    const localErrors = errorList.filter(
                      (error) => error.field != 'qtr'
                    );
                    setErrorList(localErrors);
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 btn-wrapper mb-2">
              <div className="float-right mt-2 hide-on-print">
                <Button
                  className="btn btn-success btn-search"
                  data-testid="view_detail_ia"
                  type="button"
                  onClick={handleSearchClick}
                >
                  {' '}
                  <SVGComponent iconName="Icon-search" /> Search
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
      <div className="row" id="abc11">
        {!isAllManufacturersSelected && (
          <div className="col-12 unallocated">
            <TableGrid
              onSelectionChanged={onSelectionChanged}
              selectRowIndex={selectedRowIndexValue}
              rowData={manufacturerList || []}
              helpMessage
              fullScreenView={fullScreenView}
              handleFullScreenViewClick={handleFullScreenView}
              gridHeight={fullScreenView ? '100vh' : viewPortHeight_355}
              columnDefs={AllManufacturer}
              rowSelection="multiple"
              rowMultiSelectWithClick
              data-testid="onEditingStopped"
              fileName="Manufacturer List"
              enterMovesDown
              suppressCellFocus
              singleClickEdit
              exportFile
              hideColumnsInPdf
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default OutstandingDisputesForQuarter;
